import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TallyUpdateService {
  readonly saved$ = new Subject<void>();
  // Failure counterpart to saved$ — emitted from performSave()'s error handler in both
  // grid components. Used by TallyKeypadComponent to show a failure animation on its own
  // Save button; no other consumer needs it today.
  readonly saveFailed$ = new Subject<void>();

  // Action requests emitted by the status bar, consumed by the active list component
  readonly saveRequested$ = new Subject<void>();
  readonly addRowRequested$ = new Subject<void>();
  readonly deleteSelectedRequested$ = new Subject<void>();

  // Selection state emitted by the active list component, consumed by the status bar
  readonly hasSelectionChange$ = new Subject<boolean>();

  // Voice toolbar show/hide — toggle requested by the status bar, consumed by the active
  // list component; visibility change emitted back by the list component, consumed by the status bar
  readonly voiceToggleRequested$ = new Subject<void>();
  readonly voiceVisibilityChange$ = new Subject<boolean>();
}
